<template>
  <div class="confirm">
    <div v-if="content"
         v-html="content"
         class="--margin-bottom"></div>
    <template v-if="isPrebooking">
      <checkout-payment v-if="isBankTransfer"
                        :bank-data="bankData" />
    </template>
    <template v-else-if="mover">
      <div class="--margin-bottom"
           v-html="descriptionMover && $t(descriptionMover)"></div>
      <card-flex class="confirm__mover"
                 no-box-shadow
                 mobile-wrapper-column
                 :image="mover.logo_url">
        <div class="confirm__mover__infos">
          <div class="--margin-right">
            {{$t('confirm.mover.refClient', {refClient: mover.num_client || ''})}}
            <br>
            {{$t('confirm.mover.society', {society: mover.name})}}
          </div>
          <div>
            {{$t('confirm.mover.telephone', {telephone: mover.phone_office || ''})}}
            <br>
            {{$t('confirm.mover.email', {email: mover.email || ''})}}
          </div>
        </div>
      </card-flex>
      <div class="--margin-bottom"
           v-html="bottomDescription && $t(bottomDescription)"></div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useConfigStore } from '@/stores';
import CheckoutPayment from "@/components/payments/CheckoutPayment.vue";
import CardFlex from '@/utils/components/CardFlex.vue';
import { useMoveManager, useMoveManagerEmits, useMoveManagerProps } from '@/composables/useMoveManager';

defineOptions({
  name: 'StepConfirm',
  nameClassStyle: 'step-confirm',
});

const props = defineProps(useMoveManagerProps);
const emit = defineEmits(useMoveManagerEmits);
const { getTextVersion, demand } = useMoveManager(props, {emit});

const { comparatorConfig, isPrebooking } = storeToRefs(useConfigStore());

const mover = computed(() => {
  return props.offer ? {
    ...props.offer.mover,
    ...props.offer.contact,
  } : null;
});

const stepConfig = computed(() => {
  return comparatorConfig.value.confirm;
});

const bankData = computed(() => {
  return props.offer?.failed_payment?.nextAction?.display_bank_transfer_instructions;
});

const paymentTypeConfig = computed(() => {
  if (isPrebooking.value && isBankTransfer.value) {
    return stepConfigOptions.value?.paymentTypes?.bankTransfer;
  }
  return null;
});

const bottomDescription = computed(() => {
  return stepConfigOptions.value?.bottomDescription || '';
});

const descriptionMover = computed(() => {
  return stepConfigOptions.value?.descriptionMover || '';
});

const content = computed(() => {
  return getTextVersion(paymentTypeConfig.value?.content || stepConfig.value?.content, {
    mover: mover?.value?.name,
    n2: demand.value?.n2,
  });
});

const stepConfigOptions = computed(() => {
  return stepConfig.value?.options;
});

const isBankTransfer = computed(() => {
  return !!bankData.value;
});
</script>

<style scoped lang="scss">
.confirm {
  .--margin-right {
    margin-right: 40px;
  }
  .--margin-bottom {
    margin-bottom: 20px;
  }
  &__mover {

    &__infos {
      @include breakpoint(mobile) {
        display: flex;
      }
    }

    :deep(.card-flex__img) {
      height: 70px;
    }
  }

  :deep(.checkout-payment__info) {
    margin: auto;
  }
}
</style>
